/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Gruppo } from './gruppo';
import { AuditChiamataListFilter } from './audit-chiamata-list-filter';


export interface AuditChiamataErroriExportDTO { 
    generato_il?: string;
    filtri?: AuditChiamataListFilter;
    totale_chiamate?: number;
    totale_gruppi?: number;
    troncato?: boolean;
    esempi_per_gruppo?: number;
    gruppi?: Array<Gruppo>;
}

